import React from 'react';

const ticketsData = [
  {
    title: 'Build Your Identity',
    price: 'Lasting Impressions',
    points: [
      'Boost Fan & Team Spirit',
      'Increase Audience Recognition',
      'Create Professionalism',
      'Tangible Connection to Your Brand',
      'Stand Out in Any Field',
    ],
    animationClass: 'fadeInLeft',
    delay: 100,
  },
  {
    title: 'Strengthen Your Community',
    price: 'Forge Stronger Connections',
    points: [
      'Unite Your Team or Group',
      'Show Supporter Appreciation',
      'Welcome New Members',
      'Boost Morale & Engagement',
      'Create a Sense of Belonging',
    ],
    animationClass: 'fadeInUp',
    delay: 200,
  },
  {
    title: 'Achieve Your Goals',
    price: 'A Cost-Effective Strategy',
    points: [
      'Memorable Event Giveaways',
      'Effective Fundraising Tool',
      'Attract Booth & Table Traffic',
      'Promote Your Latest Project',
      'Reward Loyal Supporters',
    ],
    animationClass: 'fadeInRight',
    delay: 300,
  },
];

export default function TicketOne({ tickets = ticketsData }) {
  return (
    <section id="th-pricing" className="ticket-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">The Power of a Tangible Brand</span>
          </div>
          <h2 className="section-title__title">More Than Just Merchandise</h2>
        </div>
        <div className="row">
          {tickets.map((ticket, index) => (
            <div
              key={index}
              className={`col-xl-4 col-lg-4 wow ${ticket.animationClass}`}
              data-wow-delay={`${ticket.delay}ms`}
            >
              <div className="ticket-one__single">
                <div className="ticket-one__title-box">
                  <div className="ticket-one__title-icon">
                    <i className="fas fa-star"></i>
                  </div>
                   <h5 className="ticket-one__title">{ticket.title}</h5>
                </div>
                <div className="ticket-one__price-box">
                  <h3>{ticket.price}</h3>
                </div>
                <ul className="list-unstyled ticket-one__points">
                  {ticket.points.map((point, idx) => (
                    <li key={idx}>
                      <div className="icon">
                        <i className="fas fa-check"></i>
                      </div>
                      <div className="text">
                        <p>{point}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 